import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { WEBSITE_BUILDER_Z_LAYERS } from "pages/secure/facility/websiteBuilder/editor/utility/websiteBuilderZLayers";
import { CSSProperties } from "styled-components";
import { useTableBuilderContext } from "../../TableBuilderContext";
import Portal from "elements/Portal";
import { useAppSelector } from "hooks/redux";
import "./tableBuilderAddDimensionButtons.scss";

export function TableBuilderAddDimensionButtons() {
  const { containerBuilderUIPortalId } = useTableBuilderContext();

  const deviceView = useAppSelector(store => store.websiteBuilderStore.editor.deviceView);

  const active = deviceView !== "mobile";

  return (
    <Portal isMounted={active} parentId={containerBuilderUIPortalId}>
      <TableBuilderAddDimensionButton type="column" />
      <TableBuilderAddDimensionButton type="row" />
    </Portal>
  );
}

type TTableBuilderAddDimensionButtonType = "row" | "column";

interface ITableBuilderAddDimensionButtonProps {
  type: TTableBuilderAddDimensionButtonType;
}

function TableBuilderAddDimensionButton(props: ITableBuilderAddDimensionButtonProps) {
  const { type } = props;

  const { tableNode, operations, containerBoundingBox } = useTableBuilderContext();

  const tableSettings = tableNode.container.settings;

  function handleClick() {
    if (type === "row") {
      if (tableSettings.body.rows.length === 0) {
        operations.insertRowBelowHead();
      } else {
        const lastRowId = tableSettings.body.rows[tableSettings.body.rows.length - 1].id;
        operations.insertRow(lastRowId, "below");
      }
    } else {
      operations.insertColumn(0, "before");
    }
  }

  function getStyle(): CSSProperties {
    const OFFSET = 10;

    let style: CSSProperties = {};
    
    if (type === "row") {
      style = {
        left: 0,
        top: containerBoundingBox.height + OFFSET,
        width: containerBoundingBox.width,
      };
    } else {
      style = {
        left: -OFFSET,
        top: 0,
        height: containerBoundingBox.height,
        transform: "translateX(-100%)",
      };
    }

    style.zIndex = WEBSITE_BUILDER_Z_LAYERS.designSpace.containerBuilderUI;

    return style;
  }

  return (
    <div
      className="table-builder-add-dimension-button"
      style={getStyle()}
      onClick={handleClick}
    >
      <FontAwesomeIcon size="sm" icon={faPlus} />
    </div>
  );
}